import { render } from "./ToolbarMenu.vue?vue&type=template&id=b021dcec"
import script from "./ToolbarMenu.vue?vue&type=script&lang=js"
export * from "./ToolbarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__